export enum BootstrapViewportEnum {
    XXL_MIN = 1400,
    XL_MIN = 1200,
    LG_MIN = 992,
    MD_MIN = 768,
    SM_MIN = 576,
    XS_MIN = 0
}